import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { version } = require('../../../package.json');

window.env.ALERTS_BUGSNAG_API_KEY &&
  Bugsnag.start({
    apiKey: window.env.ALERTS_BUGSNAG_API_KEY,
    appVersion: version,
    plugins: [new BugsnagPluginReact()],
    releaseStage: window.env.ALERTS_BASE_DOMAIN,
    onError: (event) => {
      // Drop the spec-defined ResizeObserver loop ErrorEvent (W3C ResizeObserver §3.4.6). See OPE-374.
      if (event.errors.some((e) => e.errorMessage?.startsWith('ResizeObserver loop'))) {
        return false;
      }

      return true;
    },
  });
